import "Layouts/login";

$(function () {
    $(".js-form-lost-password").validate({
        submitHandler: function (form) {
            form.submit();
        },
    });

    $(".js-not-vat-payer").on("change", function () {
        const isChecked = $(this).is(":checked"),
            $vatNumInput = $(".js-vat-num-input");

        $vatNumInput.prop("required", !isChecked);
        $vatNumInput.parents(".c-form__item").first().toggleClass("is-required", !isChecked);
    });
});

rEvent.on("Finstat.select.after", (autocompleteField, data) => {
    const form = autocompleteField.closest("form");
    const billing = form.querySelector(".js-b2b-reg-billing");

    if (billing) {
        billing.classList.remove("h-nodisplay");

        if (Object.values(data.result || []).length) {
            for (const input of billing.querySelectorAll("input, select")) {
                $(input).valid();

                if ($(input).hasClass("js-autocomplete-city")) {
                    setTimeout(() => {
                        if ($(input).hasClass("error")) {
                            $(input).focus();
                            $(input).autocomplete("search");
                            $(input).removeClass("error");
                        }
                    }, 400);
                }
            }
        }
    }
});
